
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22.445 11.889"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.999 10.889a.835.835 0 0 1-.6-.243L1.239 2.53a.832.832 0 0 1 0-1.181.852.852 0 0 1 1.186 0l8.569 7.534 9.011-7.534a.85.85 0 0 1 1.186 0 .819.819 0 0 1 0 1.172l-9.607 8.125a.826.826 0 0 1-.593.243z","fill":"#35bdd1","stroke":"#35bdd1","stroke-width":"2"}})])
          )
        }
      }
    